import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';

import VideoModalShorts from '../../components/inc/Modal/VideoModalShorts'

import '../../assets/css/0020_objects/0920_obj_essentiel_minute_comptoir_dermato.css'


class ObjEssentielMinuteComptoirDermato extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}
	componentDidMount() {
		// ouverture popin video
		// this.VideoModalShorts.openModal()
	}

	render() {
        const { datasEssentielle } = this.props;

		return (
			<div className="obj_essentiel_minute_comptoir_dermato">
				<h3 className="t_title"><strong>L'essentiel en 2 minutes</strong></h3>
				<div className="obj_essentiel_minute_focus">
					<div className="obj_push_card">
						<div className="ctn_media_card">
                            <Link onClick={() => this.VideoModalShorts.openModal()}>
                                <div className="obj_player">
                                    <picture className="ctn_player fade-in">
                                        <Image field={datasEssentielle.pageImagePush.jss}></Image>
                                    </picture>
                                </div>
                            </Link>
						</div>

						<div className="ctn_content_card">
							<div className="ctn_text_card">
								<Link onClick={() => this.VideoModalShorts.openModal()}>
                                    { datasEssentielle.pageTitle.jss && <RichText tag="h3" className="t_title" field={datasEssentielle.pageTitle.jss} /> }
                                    { datasEssentielle.pageSubTitle.jss && <RichText tag="p" className="t_desc" field={datasEssentielle.pageSubTitle.jss} /> }
								</Link>
							</div>
						</div>
						
					</div>
				</div>

				<VideoModalShorts
					onRef={ref => (this.VideoModalShorts = ref)}
					videoUrl={datasEssentielle.videoUrl.jss.value}
				/>

			</div>
		)
	}

}

export default ObjEssentielMinuteComptoirDermato